import React from 'react';
import { Dialog, DialogContent } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/NewPcButton';

interface MembershipFailDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const MembershipFailDialog: React.FC<MembershipFailDialogProps> = ({ open, setOpen }) => (
  <Dialog open={open} onOpenChange={setOpen}>
    <DialogContent
      noCloseBtn
      className="flex w-[320px] flex-col items-start justify-between p-[30px]"
    >
      <div className="flex flex-col gap-1">
        <div className="text-gr-900 Title3S18">결제가 실패하였습니다</div>
        <div className=" text-gr-700 Body5M14">
          결제수단 확인 후 재시도 해보세요.
          <br />
          지속적으로 결제가 이뤄지지 않을 경우
          <br />
          1:1 문의를 부탁드려요.
        </div>
      </div>
      <Button className="mt-5 h-[44px] w-full" onClick={() => setOpen(false)}>
        확인
      </Button>
    </DialogContent>
  </Dialog>
);

export default MembershipFailDialog;
